import React from 'react';
import superagent from 'superagent';
import ReactDOM from 'react-dom';

import { LoggedUserAdmin, LoggedUserId } from '../login/Login';

import styles from '../kalendar/Home.css';


function PrihlaseniLide(prop) {
  if (prop.lide == null) {
    return (<div className="col-9 col-sm-10"></div>);
  }
  if (prop.lide.length == 0) {
    return (<div className="col-9 col-sm-10"><i>nikdo není přihlášen</i></div>);
  }
  var poradi = 0;
  var lidiEl = prop.lide.map((clovek) => {
    poradi++;
    return (
      <div key={clovek.id_user}>
        {poradi}. {clovek.jmeno}
      </div>
    )
  });

  return (
    <div className="col-9 col-sm-10">
      {lidiEl}
    </div>
  )
}


export default class LekceEditModal extends React.Component {

  constructor() {
    super();
    this.state = {
      lekce: null,
      nadpis: null,
    };

    this.handleChangeLekce = this.handleChangeLekce.bind(this);
    this.handleChangeAktivni = this.handleChangeAktivni.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.zrusLekci = this.zrusLekci.bind(this);
    this.aktivujLekci = this.aktivujLekci.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({lekce: nextProps.lekce, nadpis: nextProps.lekce.nazev});
  }

  handleChangeLekce(event) {
    var lekce = this.state.lekce;
    switch (event.target.id) {
      case 'inputNazev': lekce.nazev = event.target.value; break;
      case 'inputDatum': lekce.datum = event.target.value; break;
      case 'inputCasOd': lekce.cas_od = event.target.value; break;
      case 'inputCasDo': lekce.cas_do = event.target.value; break;
      case 'inputLektor': lekce.lektor = event.target.value; break;
      case 'inputKapacita': lekce.kapacita = event.target.value; break;
      case 'inputPopis': lekce.popis = event.target.value; break;
    }
    this.setState({lekce: lekce});
  }

  handleChangeAktivni() {
    this.setState({chckedAktivni: !this.state.chckedAktivni});
  }

  zrusLekci() {
    event.preventDefault();
    if (this.state.lekce.pocet > 0) {
      switch (this.state.lekce.pocet) {
        case '1': var str = '\nNa lekci je přihlášena ' + this.state.lekce.pocet + ' osoba.'; break;
        case '2': var str = '\nNa lekci jsou přihlášeny ' + this.state.lekce.pocet + ' osoby.'; break;
        case '3': var str = '\nNa lekci jsou přihlášeny ' + this.state.lekce.pocet + ' osoby.'; break;
        case '4': var str = '\nNa lekci jsou přihlášeny ' + this.state.lekce.pocet + ' osoby.'; break;
        default: var str = '\nNa lekci je přihlášeno ' + this.state.lekce.pocet + ' osob.'
      }
    } else {
      var str = '';
    }
    var result = confirm("Opravdu chcete zrušit lekci " + this.state.lekce.datum + ' od ' + this.state.lekce.cas_od + '? ' + str);
    if (result != true) {
      return false;
    }
    var obdobi = this.props.datum.getFullYear() + '-' + ("0" + (this.props.datum.getMonth() + 1)).slice(-2);
    superagent.post('https://rezervace.copasedeje.cz/servis/_lekce_delete.php?').
      send('userID=' + LoggedUserId()).
      send('obdobi=' + obdobi).
      send("lekceID="+this.state.lekce.id).
      then(res => {
        $('#exampleModalCenter').modal('hide');
        var myObject = JSON.parse(res.text);
        this.props.setLekce(myObject);
      });
    return false;
  }

  aktivujLekci() {
    event.preventDefault();
    var obdobi = this.props.datum.getFullYear() + '-' + ("0" + (this.props.datum.getMonth() + 1)).slice(-2);
    superagent.post('https://rezervace.copasedeje.cz/servis/_lekce_aktivuj.php?').
      send('userID=' + LoggedUserId()).
      send('obdobi=' + obdobi).
      send("lekceID="+this.state.lekce.id).
      then(res => {
        $('#exampleModalCenter').modal('hide');
        var myObject = JSON.parse(res.text);
        this.props.setLekce(myObject);
      });
    return false;
  }

  handleSubmit(event) {
    event.preventDefault();
    var obdobi = this.props.datum.getFullYear() + '-' + ("0" + (this.props.datum.getMonth() + 1)).slice(-2);
    superagent.post('https://rezervace.copasedeje.cz/servis/_lekce_edit.php?').
      send('userID=' + LoggedUserId()).
      send('obdobi=' + obdobi).
      send("lekceID="+this.state.lekce.id).
      send("nazev="+ReactDOM.findDOMNode(this.refs.inputNazev).value).
      send("datum="+ReactDOM.findDOMNode(this.refs.inputDatum).value).
      send("casOd="+ReactDOM.findDOMNode(this.refs.inputCasOd).value).
      send("casDo="+ReactDOM.findDOMNode(this.refs.inputCasDo).value).
      send("lektor="+ReactDOM.findDOMNode(this.refs.inputLektor).value).
      send("kapacita="+ReactDOM.findDOMNode(this.refs.inputKapacita).value).
      send("popis="+ReactDOM.findDOMNode(this.refs.inputPopis).value).
      //send("aktivni="+aktivni).
      then(res => {
        $('#exampleModalCenter').modal('hide');
        var myObject = JSON.parse(res.text);
        this.props.setLekce(myObject);
      });

    return false;
  }

  render() {
    if (this.state.lekce == null)
      return null;

    let pocetStyle = '';
    if (1*this.state.lekce.pocet >= 1*this.state.lekce.kapacita) {
      pocetStyle = 'table-danger'
    } else {
      pocetStyle = 'table-success'
    }

    return (
      <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={this.handleSubmit}>
              <div className="modal-header d-block">
                <h5 className="modal-title d-flex text-danger" id="exampleModalLabel">
                  {this.state.nadpis}
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </h5>
              </div>
              <div className="modal-body">
                <div className="row form-group">
                  <div className="col-form-label col-3 col-sm-2">Název:</div>
                  <div className="col-sm-8 col-9"><input type="text" className="form-control text-left" ref="inputNazev" id="inputNazev" required value={this.state.lekce.nazev} onChange={this.handleChangeLekce} /></div>
                </div>
                <div className="row form-group">
                  <div className="col-form-label col-3 col-sm-2">Datum:</div>
                  <div className="col-sm-3 col-4"><input type="text" className="form-control text-center" ref="inputDatum" id="inputDatum" required value={this.state.lekce.datum} onChange={this.handleChangeLekce} /></div>
                </div>
                <div className="row form-group">
                  <div className="col-form-label col-3 col-sm-2">Čas:</div>
                  <div className="col-sm-8 col-9">
                    <input type="text" className="form-control text-center w-25 d-inline px-2" ref="inputCasOd" id="inputCasOd" required value={this.state.lekce.cas_od} onChange={this.handleChangeLekce} />
                    &nbsp;-&nbsp;
                    <input type="text" className="form-control text-center w-25 d-inline px-2" ref="inputCasDo" id="inputCasDo" required value={this.state.lekce.cas_do} onChange={this.handleChangeLekce} />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-form-label col-3 col-sm-2">Lektor:</div>
                  <div className="col-sm-8 col-9"><input type="text" className="form-control text-left" ref="inputLektor" id="inputLektor" value={this.state.lekce.lektor} onChange={this.handleChangeLekce} /></div>
                </div>
                <div className="row form-group">
                  <div className="col-form-label col-3 col-sm-2">Kapacita:</div>
                  <div className="col-sm-5 col-7">
                    <input type="text" className="form-control text-center w-sm-50 w-25 d-inline" ref="inputKapacita" id="inputKapacita" required value={this.state.lekce.kapacita} onChange={this.handleChangeLekce} />
                    <span className={pocetStyle + " ml-3 pl-2 pr-2 pb-2 pt-2 pointer"}>({this.state.lekce.pocet}/{this.state.lekce.kapacita})</span>
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-form-label col-3 col-sm-2">Popis:</div>
                  <div className="col-9"><textarea  className="form-control text-left" ref="inputPopis" id="inputPopis" value={this.state.lekce.popis} onChange={this.handleChangeLekce} rows="5" /></div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
                {((this.state.lekce.aktivni == 'A') && (this.state.lekce.id != 0)) ?
                  (<button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.zrusLekci}>Zrušit lekci</button>) : null
                }
                {((this.state.lekce.aktivni != 'A') && (this.state.lekce.id != 0)) ?
                  (<button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.aktivujLekci}>Aktivovat lekci</button>) : null
                }
                <button type="button" className="btn btn-success" type="submit">Uložit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// src/components/lekce/LekceEditModal.js